import { Container } from "inversify";
import "reflect-metadata";
import { TYPES } from "./types";
import { AppStateService } from "@/services/core/AppStateService";
import { ConfigService } from "@/services/core/ConfigService";
import { SecurityService } from "@/services/core/SecurityService";
import { AppointmentService } from "@/services/entities/Portal/AppointmentService";
import { ItemsService } from "@/services/entities/FLS/ItemsService";
import { VisitourService } from "@/services/Visitour/VisitourService";

const AppContainer = new Container();

// Core Services
AppContainer.bind<AppStateService>(TYPES.Services.AppStateService).to(AppStateService).inSingletonScope();
AppContainer.bind<ConfigService>(TYPES.Services.ConfigService).to(ConfigService).inSingletonScope();
AppContainer.bind<SecurityService>(TYPES.Services.SecurityService).to(SecurityService).inSingletonScope();

// Entity Services
AppContainer.bind<AppointmentService>(TYPES.Services.AppointmentService).to(AppointmentService).inSingletonScope();
AppContainer.bind<ItemsService>(TYPES.Services.ItemsService).to(ItemsService).inSingletonScope();

// Visitour Services
AppContainer.bind<VisitourService>(TYPES.Services.VisitourService).to(VisitourService).inSingletonScope();

export { AppContainer };
